import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api, BACKEND_URL } from "@/lib/api";

const fmt = (iso) => { try { return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }); } catch { return ""; } };
const abs = (u) => !u ? "" : u.startsWith("http") ? u : `${BACKEND_URL}${u}`;

export default function BlogList() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api.get("/blog").then(({ data }) => setPosts(data)).catch(() => setPosts([]));
  }, []);

  return (
    <Layout>
      <section className="max-w-[1200px] mx-auto px-6 py-16">
        <div className="mono text-xs uppercase tracking-[0.3em] text-[#C77E3C]">/ Journal</div>
        <h1 data-testid="blog-heading" className="heading text-5xl sm:text-6xl font-black uppercase tracking-tighter mt-2">Jubasmash journal</h1>
        <p className="mt-3 text-[#555] max-w-2xl">Field notes from the artisans, essays, launches, and the occasional recipe. New writing lands here first — no login required.</p>

        {posts === null && <div className="mt-10 mono text-xs uppercase tracking-[0.2em] text-[#555]">Loading…</div>}

        {posts && posts.length === 0 && (
          <div className="mt-16 brut-border bg-white p-12 text-center" data-testid="blog-empty">
            <div className="heading text-2xl font-bold uppercase">Nothing published yet</div>
            <p className="mt-2 mono text-xs uppercase tracking-[0.25em] text-[#555]">Come back soon — first essay in the oven.</p>
          </div>
        )}

        {posts && posts.length > 0 && (
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
            {posts.map((p) => (
              <Link
                key={p.blog_id}
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="brut-border bg-white group hover:brut-shadow-accent transition-all"
              >
                {p.cover_image_url ? (
                  <div className="aspect-[4/3] bg-[#EDE5D2] overflow-hidden">
                    <img src={abs(p.cover_image_url)} alt={p.title} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
                  </div>
                ) : (
                  <div className="aspect-[4/3] bg-[#1F3D2A] flex items-center justify-center text-[#C77E3C] mono text-[10px] uppercase tracking-[0.3em]">/ Journal</div>
                )}
                <div className="p-5 border-t-2 border-[#1F3D2A]">
                  <div className="mono text-[10px] uppercase tracking-[0.25em] text-[#C77E3C]">{fmt(p.published_at || p.created_at)}</div>
                  <div className="heading text-2xl font-bold uppercase mt-2 leading-tight line-clamp-3">{p.title}</div>
                  <div className="mono text-[10px] uppercase tracking-[0.25em] text-[#555] mt-3">by {p.author_name || "Jubasmash"}</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </Layout>
  );
}
